import { memo } from "react";
import Screen, { type ScreenProps } from "ui/layouts/Screen";
import { Settings } from 'ui/organizms/Merchants/KYC';

const KYCMerchantSettings = (props: ScreenProps) => (
    <Screen
        {...props}
        title='Merchants | KYC Settings'
    >
        <Settings />
    </Screen>
);

export default memo(KYCMerchantSettings);
